import { useCallback, useEffect, useState } from 'react';
import { useDimensions } from '../../../hooks/useDimensions';
import AssetIcon from '../../../components/AssetIcon';

const Bitcoin = () => {
  const { dimensions: rootDimensions, ref: rootRef } = useDimensions();
  const [children, setChildren] = useState<
    Record<
      number,
      {
        top: number;
        left: number;
        size: number;
        rotation: number;
      }
    >
  >({});

  const spawn = useCallback(() => {
    if (!rootDimensions?.height) {
      return;
    }

    const id = Math.random();
    const size = 20 + Math.random() * 80;
    const rotation = Math.floor(Math.random() * (50 - -50 + 1)) + -50;

    setChildren((prev) => {
      const updated = { ...prev };
      updated[id] = {
        top: Math.max(
          size / 2,
          Math.random() * (rootDimensions?.height ?? 0) * 0.6 - size,
        ),
        left: Math.max(
          size / 2,
          Math.random() * (rootDimensions?.width ?? 0) - size,
        ),
        size,
        rotation,
      };

      return updated;
    });

    setTimeout(() => {
      setChildren((prev) => {
        const updated = { ...prev };
        delete updated[id];
        return updated;
      });
    }, 5000);
  }, [rootDimensions?.height, rootDimensions?.width]);

  useEffect(() => {
    setInterval(spawn, 400);
  }, [spawn]);

  return (
    <div
      ref={rootRef}
      style={{
        position: 'absolute',
        top: 0,
        height: '100%',
        left: 0,
        width: '100%',
      }}
    >
      {Object.entries(children).map(([key, params]) => (
        <Item
          key={key}
          left={params.left}
          top={params.top}
          size={params.size}
          rotation={params.rotation}
        />
      ))}
    </div>
  );
};

const Item = ({
  top,
  left,
  size,
  rotation,
}: {
  top: number;
  left: number;
  size: number;
  rotation: number;
}) => {
  const [opacity, setOpacity] = useState(0);
  const [shouldMove, setShouldMove] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setOpacity(1);
    }, 100);

    setTimeout(() => {
      setShouldMove(true);
    }, 600);

    setTimeout(() => {
      setOpacity(0);
    }, 4000);
  }, []);

  return (
    <div
      style={{
        position: 'absolute',
        top,
        left,
        opacity,
        transition: 'opacity 1s ease-in-out, transform 5s ease-in-out',
        transform: shouldMove
          ? `rotate(${rotation}deg) translateY(500px)`
          : undefined,
      }}
    >
      <AssetIcon baseAsset="BTC" width={size} height={size} />
    </div>
  );
};

export default Bitcoin;
